import { useState, useEffect } from "react";
import { UoMService } from "src/services";
import { UoM } from "src/types";

export const useUoM = (uomService: UoMService) => {
  const currentUoMSetting = uomService.getLocalStorageUoMSetting();
  const [uom, setUoM] = useState<UoM>(currentUoMSetting);

  useEffect(() => {
    uomService.setLocalStorageUoMSetting(uom);
  }, [uom, uomService]);

  return [uom, setUoM] as const;
};
